import { signout } from "../app/utils/oidcUserManager";

export default function setupAxios(axios, store) {

  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    err => Promise.reject(err)
  );

  axios.interceptors.response.use(
    response => {
      const errors = response?.data?.errors;
      const isNotAuthorized =
        Array.isArray(errors) &&
        errors.some(err => err?.extensions?.code === "AUTH_NOT_AUTHORIZED");

      if (isNotAuthorized) {
        signout();
        return Promise.reject(new Error("AUTH_NOT_AUTHORIZED"));
      }

      return response;
    },
    error => {
      if (error?.response?.status === 401) {
        //window.location.href = "/logout";
        signout();
      } else {
        return Promise.reject(error);
      }
    });
}
